/* LUMLY Motion: dissolvenze in entrata, video in loop e bobina orizzontale */
(function () {
  if (window.__lumlyMotion) return; window.__lumlyMotion = 1;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function playV(el) {
    var v = el.querySelector('[data-lm-v]'); if (!v || reduce || saveData) return;
    /* i video sono in SD: nelle hero a tutto schermo su monitor grandi resta la foto ad alta risoluzione */
    if (el.closest('.lw-cine__media') && (window.innerWidth < window.innerHeight * 1.2 || (window.innerWidth * (window.devicePixelRatio || 1)) > 1800)) return;
    if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.load(); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function pauseV(el) { var v = el.querySelector('[data-lm-v]'); if (v && v.getAttribute('src')) v.pause(); }

  function init(root) {
    root = root || document;
    var els = [].slice.call(root.querySelectorAll('[data-lm]:not([data-lm-ok]), .lm-reveal:not([data-lm-ok])'));
    if (els.length) {
      if (!('IntersectionObserver' in window)) els.forEach(function (el) { el.classList.add('is-in'); playV(el); });
      else {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            var el = e.target, lm = el.hasAttribute('data-lm');
            if (e.isIntersecting) { el.classList.add('is-in'); if (lm) playV(el); }
            else if (lm) pauseV(el);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        els.forEach(function (el) {
          el.setAttribute('data-lm-ok', '');
          io.observe(el);
          var v = el.hasAttribute('data-lm') && el.querySelector('[data-lm-v]');
          if (v) {
            v.muted = true;
            v.addEventListener('playing', function () { el.classList.add('has-v'); });
            v.addEventListener('error', function () { el.classList.remove('has-v'); v.remove(); });
          }
        });
      }
    }
    root.querySelectorAll('[data-lm-reel]').forEach(reel);
    reelScroll();
  }

  /* Bobina: galleria orizzontale che scorre col dito, con il trackpad o con le frecce (nessun blocco dello scorrimento verticale) */
  function reel(sec) {
    if (sec.__reel) return; sec.__reel = 1;
    var track = sec.querySelector('[data-lm-reel-track]'), head = sec.querySelector('.lm-reel__head'); if (!track || !head) return;
    var nav = document.createElement('div'); nav.className = 'lm-reel__nav';
    nav.innerHTML = '<button type="button" aria-label="Foto precedenti"><svg viewBox="0 0 36 36" width="28" height="28" aria-hidden="true"><path d="M21 11l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" aria-label="Foto successive"><svg viewBox="0 0 36 36" width="28" height="28" aria-hidden="true"><path d="M15 11l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    head.appendChild(nav);
    var b = nav.querySelectorAll('button');
    function step() { var c = track.querySelector('.lm-reel__item'); return c ? c.getBoundingClientRect().width + 20 : 400; }
    function upd() { b[0].disabled = track.scrollLeft < 8; b[1].disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
    b[0].addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    b[1].addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
  }
  function reelScroll() {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.LumlyMotion = { init: init };
})();
